import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from '../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterLink, MatIconModule],
  template: `<nav aria-label="breadcrumb" class="breadcrumb-container">
    @for (crumb of breadcrumbs(); track crumb.url; let isLast = $last) {
    @if (!isLast && crumb.clickable) {
    <a [routerLink]="crumb.url">{{ crumb.label }}</a>
    } @else {
    <span [class.current-crumb]="isLast" [attr.aria-current]="isLast ? 'page' : null">{{
      crumb.label
    }}</span>
    } @if (!isLast) {
    <mat-icon>chevron_right</mat-icon>
    } }
  </nav>`,
  styleUrl: './breadcrumb.sass',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Breadcrumb {
  private readonly breadcrumbService = inject(BreadcrumbService);
  readonly breadcrumbs = this.breadcrumbService.breadcrumbs;
}
